import styled from 'styled-components';

const StyledFade = styled.div`
  animation: fade 0.5s linear;

  @keyframes fade {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;

export const Fade = props => <StyledFade {...props} />;

export default Fade;
